import React from 'react';

import { Icon } from '@swf/sports/components';
import type { Participants } from '@swf/sports/types/event';

import Score, { Team } from '../../../Score/Score';

import styles from './TennisUnavailable.scss';

interface Props {
  participants: Participants;
  isLoading?: boolean;
}

const ServingIcon: React.FC = () => (
  <div className={styles.icon}>
    <Icon name="marker" size="x2" />
  </div>
);

const TennisUnavailable: React.FC<Props> = ({ participants, isLoading }) => {
  const [home, away] = participants;

  return (
    <div data-testid="tennis-scoreboard-unavailable">
      <div className={styles.team}>
        <Score isTransparentBg team={Team.HOME} />
        <Score isTransparentBg team={Team.HOME} />
        <Score team={Team.HOME} isLoading={isLoading} defaultNumberOfDigits={2} />
        <ServingIcon />
        <span className={styles.name}>{home}</span>
      </div>
      <div className={styles.team}>
        <Score isTransparentBg team={Team.AWAY} />
        <Score isTransparentBg team={Team.AWAY} />
        <Score team={Team.AWAY} isLoading={isLoading} defaultNumberOfDigits={2} />
        <ServingIcon />
        <span className={styles.name}>{away}</span>
      </div>
    </div>
  );
};

export default TennisUnavailable;
